export enum RemoteAPI {
  aarCacheClear = '/self-serve-service-api/service/cache-evict/pending-transactions',
  aarCacheClearAgreements = '/self-serve-service-api/service/cache-evict/agreements',
  addLinkedBank = '/self-serve-service-api/service/banking/addBank/quovo',
  addressValidation = '/data-validation/service/validation/address',
  autoExchange = '/self-serve-service-api/service/systematics',
  bankFailure = '/self-serve-service-api/service/banking/addBank/failure',
  collegeNewFunds = '/self-serve-service-api/service/agreements/eligible/new-funds',
  custodians = '/custodian-service/service/custodians',
  eVerify = '/electronic-identity-verification-svc/service',
  createEVerify = '/self-serve-service-api/service/banking/e-verify/create',
  validateRoutingNumber = '/self-serve-service-api/service/banking/addBank/routing-validation',
  finalPurchaseTimeout = '/self-serve-service-api/service/timeout',
  finalRedemption = '/self-serve-service-api/service/redeem',
  finalDtsRedemption = '/self-serve-service-api/service/redeemdts',
  linkBankFailure = '/self-serve-service-api/service/banking/addBank/quovo/failure',
  me = '/v0/ciam-public/me',
  printConfirmation = '/self-serve-service-api/service/printConfirmation',
  productList = '/self-serve-service-api/service/listProducts',
  recurringPurchase = '/self-serve-service-api/service/systematics',
  recurringStartDate = '/self-serve-service-api/service/systematic/commencement',
  simulateLinkedBank = '/self-serve-service-api/service/banking/addBank/quovo/simulation',
  sseVerify = '/self-serve-service-api/service/banking/e-verify',
  userExists = '/data-validation-svc/service/validation/transactions-customer',
  getSchools = '/self-serve-service-api/service/global/eduInstitutions',
  getFundingTracking = '/agreement-service/api/agreements/onboarding/tracker/search',
  putFundingTracking = '/agreement-service/api/agreements/onboarding/tracker',
  getUserFundingInfo = '/self-serve-service-api/service/agreements/display/information',

  // External Financial Institution Service
  issues = '/external-financial-institution-svc/service/banks/account/issues',
  bankAccounts = '/external-financial-institution-svc/service/banks/accounts',
  initBank = '/external-financial-institution-svc/service/banks/pre-authenticator',
  bankAuth = '/external-financial-institution-svc/service/banks/authentication-status',
  onLoad = '/external-financial-institution-svc/service/banks/sync/event/load',
  onOpen = '/external-financial-institution-svc/service/banks/sync/event/open',
  onClose = '/external-financial-institution-svc/service/banks/sync/event/close',
  onAdd = '/external-financial-institution-svc/service/banks/sync/event/add',
  onSync = '/external-financial-institution-svc/service/banks/sync/event/sync',
  onStart = '/external-financial-institution-svc/service/banks/sync/start',

  //IRA contribution service managed by the NASU team
  contributionWindow = '/self-serve-service-api/service/contribution-period',

  //Custodians service managed by the NASU team
  generatePdfForm = '/nasu-svc/service/brokerage-transfer-form',

  //IRA contribution calls now made to self serve service
  IRALimit = '/self-serve-service-api/service/limit-data/search',
  minorIRALimit = '/self-serve-service-api/service/minor/limits',
  IRALimitSearch = '/self-serve-service-api/service/limit-data/search/poa',

  //Relationship manager service
  relationshipManager = '/rel-mgr-service-api/api/client-relationship/bio/rm',

  //Self-serve-service
  addBank = '/self-serve-service-api/service/banking/addBank/e-verify/evy',
  agreementMap = '/self-serve-service-api/service/banking/bank-agreements/association',
  allFunds = '/self-serve-service-api/service/agreements/fund-list',
  automax = '/self-serve-service-api/service/agreements/auto-max',
  bucketRoll = '/self-serve-service-api/service/bucketroll/isNextYearContributionAmountAvailable',
  confirmationEmail = '/self-serve-service-api/service/email/success/bep',
  costBasis = '/self-serve-service-api/service/costbasis',
  checkStatus = '/self-serve-service-api/service/banking/addBank/checkStatus',
  eligibleAgreements = '/self-serve-service-api/service/agreements/banking/eligible-agreements',
  //Custodians service managed by the NASU team
  custodianInstitutions = '/nasu-svc/service/v2/custodians',
  entityAddress = '/self-serve-service-api/service/entity/minor-address',
  existingBanks = '/self-serve-service-api/service/agreements/banks/ach',
  existingBanksServiceFeatures = '/self-serve-service-api/service/agreements/bank-agreements/association/features',
  finalPurchase = '/self-serve-service-api/service/purchases',
  fundingTransfer = '/self-serve-service-api/service/funding-custodian',
  marketVolatility = '/self-serve-service-api/service/message/volatility',
  moneyMarketEvent = '/self-serve-service-api/service/agreements/money-market/message',
  moneyMarketEventMessage = '/self-serve-service-api/service/agreements/has-money-market-message',
  pendingTransactions = '/self-serve-service-api/service/pending',
  personalInformation = '/self-serve-service-api/service/entity/details',
  productType = '/self-serve-service-api/service/agreements/products',
  recurring = '/self-serve-service-api/service/agreements/recurring',
  recurringBuyAutomax = '/self-serve-service-api/service/agreements/combined/recurring/purchase',
  purchaseValidate = '/self-serve-service-api/service/purchases/validate',
  qcdValidate = '/self-serve-service-api/service/qcd/validate',
  rothConversionValidate = '/self-serve-service-api/service/roth-ira-conversion/validate',
  redeemThresholds = '/self-serve-service-api/service/agreements/largeThresholdTrade',
  registration = '/self-serve-service-api/service/agreements/new-fund/accounts',
  sellDeliveryTimeLines = '/self-serve-service-api/service/delivery/timelines',
  stateWithholding = '/self-serve-service-api/service/stateWitholding',
  transactionHistory = '/self-serve-service-api/service/transactionHistory',
  transactionHistoryYTD = '/self-serve-service-api/service/transactionHistoryYearToDate',
  transactionLimits = '/self-serve-service-api/service/trpTransactionLimits',
  userFunds = '/self-serve-service-api/service/agreements/display/information',
  iraAutoMaxSelection = '/self-serve-service-api/service/ira-automax/eligible/selection',
  iraQCDSelection = '/self-serve-service-api/service/agreements/eligible/qcd',
  printQCD = '/self-serve-service-api/service/qcd/on-demand/pdf',
  iraAutoMaxWindow = '/self-serve-service-api/service/ira-automax/window',
  iraAutoMaxCalculation = '/self-serve-service-api/service/ira-automax/calculate',
  iraAutoMaxSubmit = '/self-serve-service-api/service/ira-automax',
  validateRecurringRedemptionIRA = '/self-serve-service-api/service/systematic/ira-limit',
  validateRedemption = '/self-serve-service-api/service/redeem/validate',
  redeemTradeDates = '/self-serve-service-api/service/redeem/validate/false',
  validateDtsRedemption = '/self-serve-service-api/service/redeemdts/validate',

  //ira-autoMax
  iraAutoMax = '/self-serve-service-api/service/ira-automax',
  autoMaxPOA = '/self-serve-service-api/service/agreements/auto-max/poa',
  // used when deleting an IRA-AutoMax
  iraAutoMaxDelete = '/self-serve-service-api/service/ira-automax',
  //Transaction exchange service
  exchangeToExistingSearch = `/self-serve-service-api/service/exchange/eligible-agreements/exchange-to-existing/search`,
  exchangeToNewSearch = `/self-serve-service-api/service/exchange/eligible-funds/exchange-to-new/search`,
  exchangeValidate = `/self-serve-service-api/service/exchange/transaction/validation`,
  exchangeExecute = `/self-serve-service-api/service/exchange/execute`,
  exchangeEmailConfirmation = `/api/pi/transaction-exchange-service/v1/api/email`,

  //User communication service
  paperlessSubscription = '/self-serve-service-api/service/paperless/subscription',
  paperlessTermsAndConditions = '/personal-investing/terms-and-conditions/paperless.model.json',

  //Rmd service
  rmdInformation = '/rmd-service-auto/api/rmd-summary-plus',
  rmdEndpoint = '/rmd-service-auto/api/rmd-summary',
  existingRMDEndpoint = '/rmd-service-auto/api/rmdSchedule',
  submitRMDapi = '/rmd-service-auto/api/schedule-rmd',

  //AAM Messages call
  getMessages = '/accountaccess-msg-svc/api/inbox-summary',

  //SSJ beneficiaries
  beneficiaries = '/self-serve-service-api/service/agreements/beneficiary',

  //Roth-Conversion
  executeRothConversion = '/self-serve-service-api/service/roth-ira-conversion',

  //Plaid service calls
  plaidBankingConfig = '/self-serve-service-api/service/plaid/banking/config',
  plaidBankingOnLoad = '/self-serve-service-api/service/plaid/banking/onLoad',
  plaidBankingOnEvent = '/self-serve-service-api/service/plaid/banking/onEvent',
  plaidBankingOnSuccess = '/self-serve-service-api/service/plaid/banking/onSuccess',
  plaidBankingOnExit = '/self-serve-service-api/service/plaid/banking/onExit',

  //Add bank plaid
  addBankPlaid = '/self-serve-service-api/service/banking/addBank/external/plaid',
  addBankPlaidLowerEnv = '/self-serve-service-api/service/banking/addBank/external/plaid/simulation',

  //QCD
  submitQCD = '/self-serve-service-api/service/qualified-charity-distribution',

  //Advisory details (RAS)
  advisoryDetailsInformation = '/aps-services/service/client/planning-summary/v3/details',

  //Financial advisor information (RAS)
  advisorsInformation = '/aps-services/service/client/planning-summary/v3/details/financial-advisor',

  //Advisor headshot renditions (RAS)
  advisorHeadshot = '/content/trp-ecl/services/public/assets/get-dm-renditons',

  //FAQ AEM Call
  faqTransferFunding = '/personal-investing/nasu/funding/transfer.model.json',
  faqMailACheck = '/personal-investing/nasu/funding/mail-your-check.model.json',
  faqRollover = '/personal-investing/nasu/funding/rollover.model.json',

  //Funding
  mailCheck = '/nasu-svc/service/brokerage-check-remittance-form',
  rolloverSalesforce = '/new-account-svc/service/salesforce/brokerage-rollover-record-creation',
  transferSalesforce = '/new-account-svc/service/salesforce/brokerage-transfer-record-creation',
  fundingAction = '/agreement-service/api/agreements/onboarding/tracker/action/funding',
}

export enum LocalAPI {
  todos = '../../../../fixtures/todo.json',
  IRALimit = '/mocks/IRALimits',
  personalInformation = '/mocks/personalInformation',
}

export interface APIEndpoint {
  remote: RemoteAPI;
  local: LocalAPI;
}

export default {
  remote: RemoteAPI,
  local: LocalAPI,
};
